module.exports = __webpack_public_path__ + "img/img3.14353393.svg";